/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Rank_Forbids_MultideckInputs */



/**
* | output |
* | --- |
* | "Multideck is not allowed in National or Continental championships" |
*
* @param {Err_Tournament_Rank_Forbids_MultideckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_rank_forbids_multideck = /** @type {((inputs?: Err_Tournament_Rank_Forbids_MultideckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Rank_Forbids_MultideckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le multi-deck n'est pas autorisé dans le championnat national ou continental")
	if (locale === "es") return /** @type {LocalizedString} */ ("El multideck no está permitido en el Campeonato Nacional o Continental")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Multideck não é permitido em torneios National Championship ou Continental Championship")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il multideck non è consentito nel Campionato Nazionale o Continentale")
	return /** @type {LocalizedString} */ ("Multideck is not allowed in National or Continental championships")
});